import { useSearchParams } from "react-router-dom";
import { use, useEffect, useState } from "react";
import ServerSettingsSerivce from "../../../services/server-setting-service";
import Breadcrumbs from "../../../components/breadcrumbs";
import GoogleCredentialsUploadForm from "./ui/google-credentials-form";
import GoogleCredentialsService from "../../../services/GoogleCredentialsService";
import { GoogleCredentials, ServerSetting } from "../../../models";
import ServerSettingForm from "./ui/server-setting-form";
import ServerSettingSkeleton from "./skeletons/server-setting-skeleton";

export default function ServerSettingPage() {
  const [searchParams] = useSearchParams();
  const [setting, setSetting] = useState<ServerSetting>();
  const googleService = new GoogleCredentialsService();
  const serverSettingService = new ServerSettingsSerivce();
  const [googleCredential, setGoogleCredentials] =
    useState<GoogleCredentials>();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    Promise.all([fetchGoogleCredentials(), fetchServerSetting()]).then(() => {
      setLoading(false);
    });
  }, [searchParams.get("reload")]);
  const fetchGoogleCredentials = async () => {
    try {
      const result = await googleService.getGoogleCredentials();
      setGoogleCredentials(result);
    } catch (error) {
      console.log(error);
    }
  };
  const fetchServerSetting = async () => {
    try {
      const result = await serverSettingService.getServerSettings();
      setSetting(result);
    } catch (error) {
      console.log(error);
    }
  };
  console.log({setting})
  return (
    <main className="max-w-3xl ">
      <Breadcrumbs
        breadcrumbs={[
          { label: "Server Settings", href: "/admin/server-settings" },
        ]}
      />
      {loading?<ServerSettingSkeleton/>:<>
      <GoogleCredentialsUploadForm
        googleCredentials={googleCredential}
      ></GoogleCredentialsUploadForm>
      {setting ? (
        <ServerSettingForm serverSetting={setting}></ServerSettingForm>
      ) : null}
      </>}
      
    </main>
  );
}
